
const STORAGE_KEY_BLOCKED = 'cabanas_blocked_dates';
const STORAGE_KEY_PRICES = 'cabanas_custom_prices';

export const dateService = {
    // Retorna todas as datas bloqueadas (array de strings YYYY-MM-DD)
    getBlockedDates: () => {
        const stored = localStorage.getItem(STORAGE_KEY_BLOCKED);
        return stored ? JSON.parse(stored) : [];
    },

    // Retorna preços customizados (objeto { 'YYYY-MM-DD': price })
    getCustomPrices: () => {
        const stored = localStorage.getItem(STORAGE_KEY_PRICES);
        return stored ? JSON.parse(stored) : {};
    },

    // Salva datas bloqueadas
    saveBlockedDates: (dates) => {
        localStorage.setItem(STORAGE_KEY_BLOCKED, JSON.stringify(dates));
    },

    // Salva preços customizados
    saveCustomPrices: (prices) => {
        localStorage.setItem(STORAGE_KEY_PRICES, JSON.stringify(prices));
    },

    // Gera lista de datas entre inicio e fim (inclusive)
    getDatesInRange: (startDate, endDate) => {
        const dates = [];
        let currentDate = new Date(startDate);
        const end = new Date(endDate);

        while (currentDate <= end) {
            dates.push(currentDate.toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    },

    // Bloqueia um período
    blockRange: (startDate, endDate) => {
        const currentBlocked = dateService.getBlockedDates();
        const rangeDates = dateService.getDatesInRange(startDate, endDate);

        // Adiciona apenas as que não estão bloqueadas ainda
        const newBlocked = [...new Set([...currentBlocked, ...rangeDates])];

        dateService.saveBlockedDates(newBlocked);
        return newBlocked;
    },

    // Desbloqueia um período
    unblockRange: (startDate, endDate) => {
        const currentBlocked = dateService.getBlockedDates();
        const rangeDates = dateService.getDatesInRange(startDate, endDate);

        const newBlocked = currentBlocked.filter(date => !rangeDates.includes(date));

        dateService.saveBlockedDates(newBlocked);
        return newBlocked;
    },

    // Define preço para um período
    setPriceRange: (startDate, endDate, price) => {
        const currentPrices = dateService.getCustomPrices();
        const rangeDates = dateService.getDatesInRange(startDate, endDate);

        rangeDates.forEach(date => {
            currentPrices[date] = parseFloat(price);
        });

        dateService.saveCustomPrices(currentPrices);
        return currentPrices;
    },

    // Verifica se uma data específica está bloqueada
    isDateBlocked: (dateString) => {
        const dates = dateService.getBlockedDates();
        return dates.includes(dateString);
    },

    // Obtém o preço de uma data (default 500)
    getPrice: (dateString) => {
        const prices = dateService.getCustomPrices();
        return prices[dateString] || 500;
    },

    // Calcula preço total para um período
    calculateTotal: (checkIn, checkOut) => {
        if (!checkIn || !checkOut) return 0;

        const dates = dateService.getDatesInRange(checkIn, checkOut);
        // Remove o checkout day da contagem de diárias
        dates.pop();

        if (dates.length === 0) return 0;

        return dates.reduce((total, date) => {
            return total + dateService.getPrice(date);
        }, 0);
    }
};
